import a from "../components/thumbnail.mjs";
const t = a;
export {
  t as default
};
